import { FaUtensils, FaCalendar, FaClock, FaSmile } from 'react-icons/fa';

const counter = [
    {
        id: 1,
        icon: <FaUtensils />, // Utensils icon
        title: 'Dishes Served',
        count: '1000',
    },
    {
        id: 2,
        icon: <FaCalendar />, // Calendar icon
        title: 'Events Hosted',
        count: '250',
    },
    {
        id: 3,
        icon: <FaClock />, // Clock icon
        title: 'Years of Service',
        count: '10',
    },
    {
        id: 4,
        icon: <FaSmile />, // Smile icon
        title: 'Satisfied Customers',
        count: '30000',
    },
];

export default counter;